<template>
    <MainContainer :hideNavSidebar="true">
        <template #sidebar>
            <h3>Self-Learning</h3>
            <p>
                In diesem Bereich befinden sich Tutorial-Videos zu verschiedenen
                Themen in der Verwaltung. Sie können sich diese Anschauen um die
                Arbeitsabläufe in der Verwaltung kennnenzulernen.
            </p>
        </template>
        <section class="howto">
            <div class="howto-videos">
                <b-card-group columns>
                    <b-card
                        v-for="item in items"
                        :key="item.id"
                        :title="item.title"
                        :img-src="item.thumbnail_src"
                        img-alt="Image"
                        img-top
                    >
                        <b-card-text>{{ item.description }}</b-card-text>
                        <b-button variant="primary" @click="showVideo(item)"
                            >Video ansehen</b-button
                        >
                        <template v-if="item.published">
                            <b-card-text class="mt-3 small text-muted">{{
                                $moment(item.published).format("DD.MM.Y")
                            }}</b-card-text>
                        </template>
                    </b-card>
                </b-card-group>
            </div>
            <EditModal
                id="howtoVideoModal"
                size="xl"
                buttonText="OK"
                :title="selected.title"
            >
                <template v-if="selected.data">
                    <VideoView :src="selected.data.file_id" />
                    <div class="description">
                        {{ selected.data.description }}
                    </div>
                </template>
            </EditModal>
        </section>
    </MainContainer>
</template>

<script>
// @ is an alias to /src
import { ApiFactory } from "@/api/ApiFactory";
import CommonView from "@/mixins/CommonView/CommonView";
import MainContainer from "@/components/MainContainer/MainContainer";
import EditModal from "@/components/EditModal/EditModal";
import VideoView from "@/components/VideoView/VideoView";
import DummyTutorial from "@/assets/images/dummy_tutorial.jpg";

import "./Howto.scss";

const HowtoApi = ApiFactory.get("howto");
const FilesApi = ApiFactory.get("files");

export default {
    name: "howto",
    mixins: [CommonView],
    components: {
        MainContainer,
        EditModal,
        VideoView
    },
    data() {
        return {
            api: HowtoApi
        };
    },
    methods: {
        process(item) {
            item.thumbnail_src = DummyTutorial;
            this.downloadThumbnails(item);
            return item;
        },
        async downloadThumbnails(item) {
            const response = await FilesApi.getFile(item.thumbnail_id);
            if (response.ok) {
                item.thumbnail_src = URL.createObjectURL(response.blob);
            }
        },
        showVideo(item) {
            this.dataSet(item, null, item.title);
            this.$root.$emit("bv::show::modal", "howtoVideoModal");
        }
    }
};
</script>
